import React from 'react';
import styled from 'styled-components';

import Footer from '../containers/Footer';

const Wrapper = styled.div`
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center ;
  margin: 0 36px;
  margin-top: 20px;
  padding-bottom: 100px;
`;

const TitleText = styled.h2`
  font-size: 20px;
  line-height: 24px;
  margin: 20px 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.basic1000};
`;

const Text = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  text-align: center;
  color: ${({ theme }) => theme.colors.basic2000};
`;

interface TermsProps {
  hideFooter?: boolean;
}

const Terms = ({ hideFooter = false }: TermsProps) => (
  <Wrapper>
    <TitleText>TÉRMINOS Y CONDICIONES GENERALES</TitleText>

    <h4>I. Definiciones.</h4>
    <Text>
        Las siguientes expresiones tendrán en los presentes Términos y Condiciones el siguiente significado que se les asigna en cada caso, a menos que el contexto requiera otra interpretación:
        <br /><br />
        - "Prestix", refiere a CORVALÁN 1160 S.A., sociedad incorporada bajo las leyes de la Argentina, con CUIT 30-71005426-2; con domicilio en Maipú 255, Piso 5, Ciudad Autónoma de Buenos Aires, Argentina.
        <br />
        - "Prestix" es una marca registrada y denominación de una aplicación móvil y una página web (o sitio), y un sistema informático de propiedad exclusiva de CORVALÁN 1160 S.A.
        <br />
        - "Usuario" y/o "Usted" hacen referencia a vuestra persona, en tanto utilice el sitio y la aplicación Prestix, solicite asistencia de dinero de "Prestix" y/o la reciba ("Préstamo") y/o utilice cualquiera de los servicios brindados a través del sitio y la "aplicación Prestix" (los "Servicios").
    </Text>

    <h4>II. Aspectos generales. Acceso al sitio y aplicación Prestix.</h4>
    <Text>
        El presente documento establece los términos y condiciones generales (los "Términos y Condiciones Generales") que rigen (i) el acceso al sitio "www.Prestix.com.ar" y la aplicación móvil "Prestix" (en adelante "el sitio" y la "aplicación Prestix") y (ii) la utilización de cualquiera de los productos o servicios (incluyendo Préstamos y Financiaciones) disponibles o accesibles a través del sitio y la aplicación Prestix ofrecidos por Prestix (los "Servicios").
        <br /><br />
        El Usuario reconoce que antes de aceptar los Términos y Condiciones ha tomado pleno conocimiento de los mismos, ha podido acceder a los mismos al ingresar al sitio web como así también pudo leerlos y/o descargarlos durante el proceso de solicitud por los canales detallados previamente, cuenta con copia de ellos a su disposición, pudiendo guardarlos en su ordenador, imprimirlos o retirar copia firmada por Prestix en el domicilio especial fijado por la misma.
        <br /><br />
        El acceso al sitio y la aplicación Prestix sólo está disponible para las personas humanas que (i) sean mayores de dieciocho (18) años, y (ii) tengan capacidad legal para contratar. 
    </Text>

    <h4>III. Relación jurídica entre las Partes.</h4>
    <Text>
        Las partes acuerdan que conforme a los artículos 286, 288, 1105, 1106 y concordantes del Código Civil y Comercial de la Nación, los presentes Términos y Condiciones Generales, y su aceptación por parte del Usuario vía electrónica o informática, son un compromiso válido y legal entre el Usuario y Prestix, en especial, pero no limitado, en relación a los Préstamos y/o Servicios que el Usuario solicite a Prestix y/o le sean otorgados o prestados por Prestix.
    </Text>

    <h4>IV. Solicitud de Servicios de Crédito.</h4>
    <Text>
        El Usuario, luego de ingresar a su Cuenta en el sitio y la aplicación Prestix, podrá solicitar a Prestix, en todo momento, el otorgamiento de una asistencia en dinero (el "Préstamo").
    </Text>

    <h4>V. Precio de los Servicios.</h4>
    <Text>
        El Usuario al comunicar la Aceptación de la Propuesta de Préstamo, siempre que el Préstamo sea acreditado en su cuenta bancaria, reconoce y acepta que deberá a Prestix los montos acordados más los intereses detallados en la oferta.
    </Text>

    <h4>VI. Pago de las cuotas del préstamo.</h4>
    <Text>
        El Usuario, en este acto, mediante la aceptación de los Términos y Condiciones, se compromete al pago de la totalidad de las cuotas del préstamo mediante los medios indicados en la plataforma.
    </Text>

    <h4>VII. Política de Privacidad y Protección de Datos Personales.</h4>
    <Text>
        Al prestar conformidad por los presentes Términos y Condiciones, el Usuario también está prestando conformidad a la Política de Privacidad y a todos los derechos y obligaciones contenidos en el sitio y la aplicación Prestix.
    </Text>

    <h4>VIII. Cláusulas adicionales.</h4>
    <Text>
        El Usuario en oportunidad del uso del sitio y la aplicación Prestix se obliga a no ejecutar y/o realizar operaciones y/o actos que pongan en riesgo la seguridad de la plataforma.
    </Text>

    <h4>IX. Caso Especial. Autorización de Descuento.</h4>
    <Text>
        Las cláusulas de la presente sección IX son aplicables a Usuarios que resulten empleados afiliados o afiliables a una entidad Mutual y/o Sindicato y/o Cooperativa que posea convenio de descuento de haberes.
    </Text>

    <h4>X. Notificaciones. Domicilio Prestix.</h4>
    <Text>
        El Usuario acepta la plena validez de las notificaciones enviadas a Prestix y recibidas de Prestix, a través del sitio y la aplicación Prestix y/o por correo electrónico.
    </Text>

    {!hideFooter && <Footer />}
</Wrapper>
);

export default Terms;
